import { createContext } from 'react';
import { ReviewCheckToggleContextType } from '#baseMenu/components';

const ReviewCheckToggleContext = createContext<ReviewCheckToggleContextType>(null);

export { ReviewCheckToggleContext };
